export default __webpack_public_path__ + "static/media/ic_partners_b.52e5f5d8.svg";